<template>
  <div
    v-click-outside="onClickOutside"
    class="tw-cursor-pointer"
    :class="`${isOpen ? 'tw-pb-0' : 'tw-pb-2'}`"
  >
    <div
      class="tw-flex tw-justify-between tw-items-center hover:tw-text-custom-teal"
      @click="isOpen = !isOpen"
    >
      <span class="tw-font-semibold">{{ item.name }}</span> <i class="tw-px-2 fas fa-chevron-down" />
    </div>
    <ul v-if="isOpen">
      <slot />
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({
        id: 0,
      }),
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  methods: {
    onClickOutside() {
      this.isOpen = false;
    },
  },
};
</script>
